import { render } from "./Banner.vue?vue&type=template&id=535dbf2d&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=535dbf2d&scoped=true&lang=css"

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@4.47.0_supports-color@8.1.1_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535dbf2d"]])

export default __exports__